
export default "/assets/lock-closed-micro.79dc2006.svg"